import React from "react";
import PropTypes from "prop-types";
import { TableRow, TableCell, Checkbox, TableSortLabel } from "@mui/material";
import { COLOR_CODE } from "@/utils/constants/colors";

const DataTableHead = ({
  columns,
  sortConfig,
  handleSort,
  isSelectAll,
  records,
  selectedRows,
  handleSelectAll
}) => (

  <TableRow>
    <TableCell sx={{
      width: '60px',
    }}>
      <Checkbox
        size="small"
        className="custom-checkbox"
        checked={isSelectAll || (records?.length > 0 && records.every(record =>
          selectedRows.some(selected => selected.uuid === record.uuid)
        ))}
        onChange={handleSelectAll}
        indeterminate={!isSelectAll && selectedRows?.length > 0 && selectedRows?.length < records.length}
      />
    </TableCell>
    {columns.map((column) => (
      <TableCell className="custom-data-table-cell"
        key={column.name_of_db_column || column.label_of_column} // Use a unique property as the key
        align="left"
      >
        <TableSortLabel
          active={sortConfig?.key === column.name_of_db_column}
          direction={sortConfig?.key === column.name_of_db_column ? sortConfig?.direction || 'asc' : 'asc'}
          onClick={() => column?.hideSortIcon ? null : handleSort(column.name_of_db_column)}
          hideSortIcon={column?.hideSortIcon ?? false}
          sx={{
            color: COLOR_CODE._EFEFEF + ' !important',
            '&.Mui-active': {
              color: COLOR_CODE._EFEFEF + ' !important',
            },
            '&:hover': {
              color: COLOR_CODE._EFEFEF + ' !important',
            },
            '& .MuiTableSortLabel-icon': {
              color: COLOR_CODE._EFEFEF + ' !important',
            },
          }}
        >
          {column.label_of_column}
        </TableSortLabel>
      </TableCell>
    ))}
    <TableCell sx={{
      width: '60px',
    }}>
    </TableCell>
  </TableRow>

);

DataTableHead.propTypes = {
  columns: PropTypes.array.isRequired,
  sortConfig: PropTypes.object,
  handleSort: PropTypes.func.isRequired,
  isSelectAll: PropTypes.bool.isRequired,
  records: PropTypes.array.isRequired,
  selectedRows: PropTypes.array.isRequired,
  handleSelectAll: PropTypes.func.isRequired
};

export default DataTableHead;
